/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedTariffPlanListDto } from '../../models/backend-paginated-tariff-plan-list-dto';

export interface SubscriptionTariffPlanList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function subscriptionTariffPlanList(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionTariffPlanList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedTariffPlanListDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionTariffPlanList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedTariffPlanListDto>;
    }),
  );
}

subscriptionTariffPlanList.PATH = '/api/subscription/tariff_plan/';
